import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../api/login";
import "../styles/login.css";

const PasswordPage = ({ setIsAuthenticated }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const result = await login(password);
    setLoading(false);

    if (result.success) {
      localStorage.setItem(
        "authData",
        JSON.stringify({ expiresAt: result.expiresAt })
      );

      navigate("/");
    } else {
      setError(result.message);
    }
  };

  return (
    <div className="password-wrapper">
      <div className="password-box">
        <h4>🔒 Enter Password</h4>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="username"
            autoComplete="username"
            style={{ display: "none" }}
            tabIndex={-1}
          />
          <input
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
            disabled={loading}
          />
          <button type="submit" disabled={loading}>
            {loading ? "Authenticating..." : "Unlock"}
          </button>
        </form>
        {error && <p className="error">{error}</p>}
      </div>
    </div>
  );
};

export default PasswordPage;
